function initializeWordSlider() {
    const wordSlider = $(".word-slider");
    wordSlider.each((siderIndex, slider) => {
        const words = $(slider).find(".word-slider_word");
        let startingIndex = 1;
        setInterval(() => {
            let currentIndex = startingIndex++ % words.length;
            let previousIndex = currentIndex == 0 ? words.length - 1 : currentIndex - 1;
            $(words[currentIndex]).removeClass("inactive").addClass("active");
            $(words[previousIndex]).removeClass("active").addClass("inactive").on("transitionend", () => {
                $(words[previousIndex]).removeClass("inactive");
            });
        }, 3000);
        setInterval(() => {
            $('.hero-banner.text-anim .word-slider .word-slider_word').each(function (index) {
                var varWidth = $(this).find('.for-width').width() + 10;
                $('.for-width').hide();
                $(this).attr("data-width", varWidth)
                $('.hero-banner.text-anim .word-slider').css({ width: $('.hero-banner.text-anim .word-slider .word-slider_word.active').attr("data-width"), });

            });
        }, 100);
    });
}


$('.hero-banner.text-anim .word-slider .word-slider_word').each(function (index) {
    var text = $(this).text().replace(/ /g, "_").replace(/-/g, "_");
    $(this).append('<p class="for-width">' + text + '</p>')
    // var varWidth = $(this).find('p').width() + 10;
    // $('.for-width').hide();
    // $(this).attr("data-width", varWidth)
    var varheight = $(this).parent().height();

    $(this).parent().css("height", varheight)
});

$(window).on("load", function () {
    setTimeout(function(){
        initializeWordSlider();
    }, 2000); 
});

